module.exports = __webpack_public_path__ + "img/settings.5f9f2ea6.svg";